import { Label as LabelDs, Scrollbox, Typography } from "@packages/ds";
import styled from "styled-components";

export const Form = styled.form`
  display: grid !important;
  gap: 16px;
  width: 100%;
  padding: 0;
  font-size: 14px;
  line-height: 24px;

  .label .required-notice {
    vertical-align: middle;
  }

  ${Scrollbox},
  .input-field {
    width: 100%;
  }

  .text-area-field {
    margin-bottom: 16px;
  }

  .ide-field {
    width: 100%;
    height: 300px;
  }

  label {
    font-size: 14px;
  }

  textarea {
    font: normal 15px/20px "Open Sans";
    color: var(--section-ebony-light-color, var(--ebony-light));
  }

  input::placeholder,
  textarea::placeholder {
    font-family: "Open Sans";
    color: var(--section-granite-color, var(--granite));
    opacity: 1;
  }
`;

export const Field = styled.div`
  position: relative;
  &.large {
    width: 100% !important;
  }
`;

export const Label = styled(LabelDs)`
  margin-bottom: 0px;
`;

export const DialogWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
`;

export const Header = styled.header`
  font-size: 14px;
  margin: 0 !important;

  > div {
    display: inline-block;
  }
  svg {
    vertical-align: middle;
  }

  p {
    margin: 24px 0 0 0;
  }
`;
export const Title = styled(Typography.Title)`
  display: inline-block;
  vertical-align: middle;
  margin-left: 23px;
`;

export const Options = styled.div`
  margin-top: 24px;
  .checkbox-field {
    margin-bottom: 10px;
  }
`;

export const Footer = styled.footer`
  display: flex;
  margin-top: 20px;

  button {
    margin-right: 8px;
  }
  #remove {
    margin-right: 0;
    margin-left: auto;
  }
`;

export const Description = styled(Typography.BodyText)`
  margin-top: 28px;
`;

export const InputFieldWrapper = styled.div`
  .input-field {
    margin-top: 16px;
  }
`;

export const ActionButtonsContainer = styled.div<{ isEdit?: boolean }>`
  button#remove {
    float: right;
  }
  ${({ isEdit }) =>
    isEdit
      ? ""
      : `display:flex;
      align-items:center;
      justify-content:center;`}
  margin-top: 41px;
`;

export const SelectWrapper = styled.div`
  margin-bottom: 16px;
`;

export const Disclaimer = styled.p`
  all: unset;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: var(--mode-text-neutral-default-weak);
  display: block;
  margin-top: 8px;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  & > *:first-child {
    flex-grow: 1;
  }

  button {
    margin-top: 8px;
  }
`;

export const CostInfoWrapper = styled.div`
  margin: 12px 0;
  ${Typography.BodyText} {
    display: inline;
    line-height: 16px;
    color: var(--color-platform-grey-700);
    font-size: 13px;
    font-weight: 600;
  }
  a {
    font-weight: 600;
    font-size: 13px;
  }
`;
